import { createAction } from 'redux-actions'
import fetch from 'lib/fetch'

export const TOGGLE_SOURCE_UPGRADE_REVIEW = 'TOGGLE_SOURCE_UPGRADE_REVIEW'
export const toggleSourceUpdateReview = createAction(TOGGLE_SOURCE_UPGRADE_REVIEW)

export const TOGGLE_SOURCE_UPGRADE_REVIEW_ACK = 'TOGGLE_SOURCE_UPGRADE_REVIEW_ACK'
export const toggleSourceUpdateReviewAck = createAction(TOGGLE_SOURCE_UPGRADE_REVIEW_ACK)

export const TOGGLE_SOURCE_UPGRADE_CONFIRM = 'TOGGLE_SOURCE_UPGRADE_CONFIRM'
export const toggleSourceUpdateConfirm = createAction(TOGGLE_SOURCE_UPGRADE_CONFIRM)

export const REQUEST_SOURCE_VERSIONS = 'REQUEST_SOURCE_VERSIONS'
export const REQUEST_SOURCE_VERSIONS_ERROR = 'REQUEST_SOURCE_VERSIONS_ERROR'
export const RECEIVE_SOURCE_VERSIONS = 'RECEIVE_SOURCE_VERSIONS'

export const fetchSourceVersions = (workspaceSlug, sourceSettingSlug) => ({
  types: {
    request: REQUEST_SOURCE_VERSIONS,
    failure: REQUEST_SOURCE_VERSIONS_ERROR,
    receive: RECEIVE_SOURCE_VERSIONS
  },
  payload: { workspaceSlug, sourceSettingSlug },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/projects/${sourceSettingSlug}/versions`).then(res => {
    if (!res.ok) {
      const error = new Error('Unable to fetch source versions')
      error.code = res.status
      throw error
    }
    return res.json()
  })
})

export const REQUEST_SOURCE_UPGRADE = 'REQUEST_SOURCE_UPGRADE'
export const REQUEST_SOURCE_UPGRADE_ERROR = 'REQUEST_SOURCE_UPGRADE_ERROR'
export const RECEIVE_SOURCE_UPGRADE = 'RECEIVE_SOURCE_UPGRADE'

export const fetchSourceUpgrade = (workspaceSlug, sourceSettingSlug) => ({
  types: {
    request: REQUEST_SOURCE_UPGRADE,
    failure: REQUEST_SOURCE_UPGRADE_ERROR,
    receive: RECEIVE_SOURCE_UPGRADE
  },
  payload: { workspaceSlug, sourceSettingSlug },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/projects/${sourceSettingSlug}/upgrade`).then(res => {
    if (!res.ok) {
      const error = new Error('Unable to fetch source upgrade')
      error.code = res.status
      throw error
    }
    return res.json()
  })
})

export const REQUEST_SOURCE_UPGRADE_CONFIRM = 'REQUEST_SOURCE_UPGRADE_CONFIRM'
export const REQUEST_SOURCE_UPGRADE_CONFIRM_ERROR = 'REQUEST_SOURCE_UPGRADE_CONFIRM_ERROR'
export const RECEIVE_SOURCE_UPGRADE_CONFIRM = 'RECEIVE_SOURCE_UPGRADE_CONFIRM'

export const confirmSourceUpgrade = (workspaceSlug, sourceSettingSlug) => ({
  types: {
    request: REQUEST_SOURCE_UPGRADE_CONFIRM,
    failure: REQUEST_SOURCE_UPGRADE_CONFIRM_ERROR,
    receive: RECEIVE_SOURCE_UPGRADE_CONFIRM
  },
  payload: { workspaceSlug, sourceSettingSlug },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/projects/${sourceSettingSlug}/upgrade`, {
    method: 'POST'
  }).then(res => {
    if (!res.ok) {
      const error = new Error('Unable to confirm source upgrade')
      error.code = res.status
      throw error
    }
    return res
  })
})



// WEBPACK FOOTER //
// ./actions/source-upgrades.js